export class CheckboxRenderer {
  init(params) {
    this.params = params;

    this.eGui = document.createElement('div');
    this.eGui.className = 'flex-table-cell';

    this.input = document.createElement('i2c-checkbox');
    this.input.checked = params.data.enabled;
    this.input.value = params.data.feature;
    this.input.label = params.data.feature;

    this.input.addEventListener('i2c-change', (event) => {
      params.data.enabled = event.target.checked;
      params.data.feature = event.target.label;

      const updatedRowData = params.api.getRenderedNodes().map(node => node.data);

      params.context.methods.setValue("brand_info_mob_app_public_menus_custom", updatedRowData);
      params.context.methods.trigger();
      params.context.handleValueChanges();

      params.api.refreshCells({ force: true });
    });

    this.eGui.appendChild(this.input);

    if (params.data.deleteable) {
      const deleteIcon = document.createElement('i2c-icon-button');
      deleteIcon.setAttribute('name', 'linear-trash');
      deleteIcon.label = 'Delete';
      deleteIcon.style.cursor = 'pointer';
      deleteIcon.style.marginLeft = '10px';

      deleteIcon.addEventListener('click', async () => {
        console.log("click is working");
      
        const allData = [];
        params.api.forEachNode(node => {
          allData.push(node.data);
        });
      
        const rowIndex = params.node.rowIndex;
        console.log("row to be removed", allData);
      
        const newData = allData.filter((_, index) => index !== rowIndex);
        console.log("new data", newData);
      
        // 1. Update form value
        params.context.methods.setValue("brand_info_mob_app_public_menus_custom", newData);
        params.context.methods.trigger();
        params.context.handleValueChanges();
      
        // 2. Refresh the table
        if (params.context.handleGridApi) {
          await params.context.handleGridApi(newData);
        }
      });
      
      // deleteIcon.addEventListener('click', () => {
      //   const rowIndex = params.node.rowIndex;
      //   const newData = params.api.getRenderedNodes()
      //     .map(row => row.data)
      //     .filter((_, index) => index !== rowIndex);

      //   params.context.methods.setValue("brand_info_mob_app_public_menus_custom", newData);
      //   params.context.methods.trigger();
      //   params.context.handleValueChanges();
      //   // params.api.setRowData(newData);
      // });

      this.eGui.appendChild(deleteIcon);
    }
  }

  getGui() {
    return this.eGui;
  }

  refresh(params) {
    this.params = params;
    this.input.checked = params.data.enabled;
    return true;
  }
}
export class InputRenderer {
  init(params) {
    this.params = params;

    this.input = document.createElement('i2c-input');
    this.input.type = 'text';
    this.input.value = params.data.alternativeMethod;
    this.input.disabled = !params.data.enabled;

    this.input.addEventListener('i2c-change', (event) => {
      params.data.alternativeMethod = event.target.value;

      const updatedRowData = params.api.getRenderedNodes().map(node => node.data);
      params.context.methods.setValue("brand_info_mob_app_public_menus_custom", updatedRowData);
      params.context.methods.trigger();
      params.context.handleValueChanges();
    });

    this.eGui = this.input;
  }

  getGui() {
    return this.eGui;
  }

  refresh(params) {
    this.params = params;
    this.input.value = params.data.alternativeMethod;
    this.input.disabled = !params.data.enabled;
    return true;
  }
}

export class CheckboxRendererReal {
  init(params) {
    this.params = params;

    this.eGui = document.createElement('div');
    this.eGui.className = 'flex-table-cell';

    this.input = document.createElement('i2c-checkbox');
    this.input.checked = this.params.data.enabled;
    this.input.value = this.params.data.feature;
    this.input.label = this.params.data.feature;

    this.input.addEventListener('i2c-change', (event) => {
      this.params.data.enabled = event.target.checked;
      params.context.methods.setValue(`brand_info_mob_app_public_menus_custom[${params.rowIndex}].feature`, event.target.label);
      params.context.methods.setValue(`brand_info_mob_app_public_menus_custom[${params.rowIndex}].enabled`, event.target.checked);
      params.context.methods.setValue(`brand_info_mob_app_public_menus_custom[${params.rowIndex}].deleteable`, this.params.data.deleteable);
      params.context.methods.trigger();
      params.context.handleValueChanges();
      params.api.refreshCells({ force: true });
    });

    this.eGui.appendChild(this.input);
    if (this.params.data.deleteable) {
      const deleteIcon = document.createElement('i2c-icon-button');
      deleteIcon.setAttribute('name', 'linear-trash');
      deleteIcon.label = 'Delete';
      deleteIcon.style.cursor = 'pointer';
      deleteIcon.style.marginLeft = '10px';

      deleteIcon.addEventListener('click', () => {
        console.log("click is working")
        const rowIndex = this.params.node.rowIndex;
        // eslint-disable-next-line no-unused-vars
        const updatedData = this.params.api.getDisplayedRowAtIndex(rowIndex).data;
        console.log("this.params.node.rowIndex updatedData", this.params.api.getRenderedNodes())
        const newData = this.params.api.getRenderedNodes()
          .map(row => row.data)
          .filter((_, index) => index !== rowIndex);
        this.params.context.methods.setValue("brand_info_mob_app_public_menus_custom", newData);
        this.params.context.methods.trigger();
        this.params.context.handleValueChanges();
        this.params.api.updateGridOptions({ rowData: newData });
      });

      this.eGui.appendChild(deleteIcon);
    }

  }

  getGui() {
    return this.eGui;
  }

  refresh(params) {
    this.params = params;
    this.input.checked = this.params.data.enabled;
    return true;
  }
}

export class InputRendererReal {
  init(params) {
    this.params = params;
    this.input = document.createElement('i2c-input');
    this.input.type = 'text';
    this.input.value = params.data.alternativeMethod;
    this.input.disabled = !params.data.enabled;
    this.input.addEventListener('i2c-change', (event) => {
      this.params.data.alternativeMethod = event.target.value;
      params.context.methods.setValue(`brand_info_mob_app_public_menus_custom[${params.rowIndex}].alternativeMethod`, event.target.value);
      params.context.methods.trigger();
      params.context.handleValueChanges();
    });
    this.eGui = this.input;
  }

  getGui() {
    return this.eGui;
  }

  refresh(params) {
    this.params = params;
    this.input.value = this.params.data.alternativeMethod;
    this.input.disabled = !this.params.data.enabled;
    return true;
  }
}



export class IconRenderer {
  init(params) {
    this.params = params;
    this.eGui = document.createElement('i2c-icon');
    this.eGui.name = 'linear-menu';
    this.eGui.setAttribute('label', 'Click to drag');
  }

  getGui() {
    return this.eGui;
  }

  refresh(params) {
    this.params = params;
    return true;
  }
}

